import { useAuth } from '../../context/AuthContext';
import styles from './AuthorPanel.module.css';

import { BiArrowBack } from 'react-icons/bi';
import ButtonLink from '../../components/ButtonLink';
import Title from '../../components/Title';

export default function AuthorPanel() {
  const { logoutContextAuthor } = useAuth()
  const handleLogout = () => {
    logoutContextAuthor();
  };

  return (
    <main className={styles.page}>
      <div className={styles.container}>
        <header className={styles.header}>
          <Title color='var(--brown-300)'>Painel do Autor</Title>
          <button onClick={handleLogout} className={styles.logoutBtn}>
            <BiArrowBack size={22} />
            <span>Sair</span>
          </button>
        </header>

        <section className={styles.cardArea}>
          <div className={styles.card}>
            <h2>📚 Cadastre seus livros</h2>
            <p>Adicione novas obras ao nosso catálogo de forma simples e rápida.</p>
            <ButtonLink type='type2' path='cadastro-de-livros'>Ir para cadastro</ButtonLink>
          </div>

          <div className={styles.card}>
            <h2>✍️ Complete seu cadastro</h2>
            <p>Forneça informações adicionais para melhorar seu perfil de autor.</p>
            <ButtonLink type='type2' path='completar-perfil'>Completar perfil</ButtonLink>
          </div>
        </section>
      </div>
    </main>
  )
}
